module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "NBL_(Australia)_logo.b045ded0.svg";